import styled from 'styled-components'

export const RightColumnMatch = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 120px;
  border-radius: ${props => props.theme.primitives.radius.radius2};
  box-sizing: border-box;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.outline.surface};
`

export const HeaderRecommendation = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  svg {
    vertical-align: middle;
  }
`

export const DescriptionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`
